<template>
  <div class="breadcrumb-box">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index"
        ><span class="clickSpan" @click="goTo(index)">{{ item.text }}</span></el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("common/promise", ["breadcrumb"]),
  },
  methods: {
    goTo(index) {
      if (
        this.breadcrumb.length >= 3 &&
        index > 0 &&
        index < this.breadcrumb.length - 1
      ) {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss">
.breadcrumb-box {
  padding: 20px;
  padding-bottom: 0;
}
.clickSpan {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Breadcrumb/Breadcrumb.vue